import * as React from "react";
import {resourcesHelper} from "@ferry/portal-core";

export default class Header extends React.Component {
    public render() {
        return (
            <div className="journey-header">
                <div className="journey-header-background">
                    <a className="header-logo-link" id="goToHelloPage" href="/" target="_blank" aria-label="Link to hello page">
                        <img className="logo" src={`/${resourcesHelper.THEME_PATH}/img/brand-logo.svg`} alt={`${resourcesHelper.THEME_PATH} logo icon`} tabIndex={0}/>
                    </a>
                </div>
            </div>
        );
    }
}
